export default __webpack_public_path__ + "static/media/usmc-bg.ca7248fa.jpg";